export default __webpack_public_path__ + "static/media/Tunnel-Active-01.29f98aec.jpg";